/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {recordCompletedJourney} from '../api'

export const useMutationRecordCompletedJourney = createReactQueryMutationHook('recordCompletedJourney', recordCompletedJourney)
